import { useWorkspaceClaimedFreeNumbersQuery } from '@/types/generated/graphql';
import { ClaimedFreeNumber } from '../../../../members/members.types';

type UseClaimedFreeNumbersArgs = {
  // Only fetch when the disposition flow is actually reachable (no rewards left to claim).
  skip?: boolean;
};

export function useClaimedFreeNumbers({ skip }: UseClaimedFreeNumbersArgs = {}) {
  const { data, loading } = useWorkspaceClaimedFreeNumbersQuery({ skip, fetchPolicy: 'network-only' });

  const claimedFreeNumbers: ClaimedFreeNumber[] = (data?.workspaceClaimedFreeNumbers?.data ?? []).map((number) => ({
    id: String(number.id),
    phoneNumber: number.phoneNumber,
    friendlyName: number.friendlyName,
    price: number.currentPrice ?? undefined,
  }));

  return { claimedFreeNumbers, claimedFreeNumbersLoading: loading };
}
